import React from "react";
import RobotSendData from "./RobotSendData";

const Drivepanel = () => {

  return (
    <div className="driving-panel-old">
      <div style={{ display: "none" }}>
        <RobotSendData />
      </div>
    </div>
  );
};

export default Drivepanel;
